import { Card, CardContent, withStyles } from "@material-ui/core"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import ItemList from "../../Common/ItemList"
import FeatureItem from "./FeatureItem"

const styles = (theme) => ({
  integrationInfoCard: {
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: "20px",
    marginTop: theme.spacing(2),
    padding: 0,
  },
  cardContent: {
    padding: "0!important",
    margin: 0,
  },
})

const Features = (props) => {
  const { classes } = props

  const features = useSelector((state) => state.feature.features)

  const [items, setItems] = useState([])

  useEffect(() => {
    setItems(
      features.map((feature) => {
        return (
          <FeatureItem
            key={feature.id}
            featureId={feature.id}
            title={feature.name}
            enabled={feature.enabled}
            instructions={feature.instructions}
          />
        )
      }),
    )
  }, [features])

  return (
    <Card className={classes.integrationInfoCard}>
      <CardContent className={classes.cardContent}>
        <ItemList items={items} />
      </CardContent>
    </Card>
  )
}

export default withStyles(styles)(Features)
